const angular = require('angular');

(function(angular) {
  'use strict';

  angular.module('esn.mailto-handler', []);

})(angular);

require('./directive.js');
require('./constant');
